import * as React from 'react';
import type { Invoice } from 'contracts/tracking-v2/invoices';
import { api, handleApiError } from 'services/api';

export const useFetchInvoice = () => {
  const fetchInvoice = React.useCallback(async (invoiceId: string | number) => {
    try {
      const url = `/tracking-v2/invoices/${invoiceId}`;
      const { data } = await api.get<Invoice>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    fetchInvoice,
  };
};